/* eslint-disable */
export const protobufPackage = 'com.celertech.marketdata.api.enums.pricetype';

export enum PriceType {
    FULL_AMOUNT = 1,
    VWAP = 2,
    UNRECOGNIZED = -1
}
